import {IPropertyConfiguratorSearchFormValuesType} from "../views/PropertyConfigurator";

export const getValuesWithCurrentSearchFieldState = (
    formValues: IPropertyConfiguratorSearchFormValuesType,
    name?: string,
    value?: unknown
): IPropertyConfiguratorSearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
import {IPropertyConfiguratorSearchFormValuesType} from "../views/PropertyConfigurator";

export const getValuesWithCurrentSearchFieldState = (
    formValues: IPropertyConfiguratorSearchFormValuesType,
    name?: string,
    value?: unknown
): IPropertyConfiguratorSearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
